import { Link } from "react-router-dom";
import { BOM } from "../../../services/definedMethod";


export const labelConfig = {
  securityProduct: "Security Product",
  editSecurityProduct:"Edit Security Product",
  addSecurityProduct:"Create New Security Product",
  securityProductListing: "Security product Listing",
  updateSecurityProduct:"Update Security Product",
  createSecurityProduct:"Create Security Product",
  newSecurityProductMsg:"Security Product was successfully created",
  viewSecurityProduct:"View Security Product"
};

export const apiConfig={
  GetSecurityProducts: BOM.baseUrl("fixedincomeproducts", "treasury"),
  Holidays: BOM.baseUrl("holidays"),  
}

export const staticConfig={
    newSecurityProduct: [
        { title: <Link to="/security-product">{labelConfig.securityProduct}</Link> },
        {
          title: labelConfig.addSecurityProduct,
        },
      ],
      viewSecurityProduct: [
        { title: <Link to="/security-product">{labelConfig.securityProduct}</Link> },
        {
          title: labelConfig.viewSecurityProduct,
        },
      ],

      editSecurityProduct: [
        { title: <Link to="/security-product">{labelConfig.securityProduct}</Link> },
        {
          title: labelConfig.updateSecurityProduct,
        },
      ],

      manageSecurityProduct: [
        { title: labelConfig.securityProduct },
      ],
}